<app-card class="max-w-md animated slideInUp !animate-duration-[1s]">
  <div class="flex flex-col items-center justify-center py-12 px-6 text-center">
    <!-- Lock Icon -->
    <div class="mb-6">
      <div class="theme-border theme-shadow rounded-full p-4 bg-red">
        <app-icon [name]="icon()" [size]="iconSize()"></app-icon>
      </div>
    </div>

    <!-- Message -->
    <div class="max-w-md font-bold text-xl color-dark">
      {{ message() }}
    </div>
    <div class="mt-6">
      <app-button
        color="purple"
        fill="solid"
        shape="round"
       
       
        (click)="navigateToHome()"
      >
        Go to Home
      </app-button>
    </div>
  </div>
</app-card>
